import React from 'react';
import { connect } from 'react-redux';
import { PatientCareCenterNoteSection } from 'PatientCareCenter/Note';
import styles from './Common.module.css';
import { DBDropDownObjective, ObjectiveFlag, ToolTipBulb, DBTextFieldObjective, DBTextAreaObjective, DBTextArea } from '_components';

const headingSitStatStandDyn = ['Normal', 'Good', 'G-/F+', 'Fair', 'Poor+', 'Poor'];
const headingSitDynStandStat = ['Normal', 'Good', 'G-/F+', 'Fair', 'Fair-', 'Poor+', 'Poor'];


const sittingStaticTopic = 'Sitting - Static';
const descriptionSitStatStandDyn = [
    'Able to maintain balance against maximal resistance',
    'Able to maintain balance against moderate resistance',
    'Accepts minimal resistance',
    'Able to sit unsupported without balance loss and without UE support',
    'Able to maintain with minimal assistance from individual or chair',
    'Unable to maintain balance - requires mod/max support from individual or chair'
];

const sittingDynamicTopic = 'Sitting - Dynamic';
const descriptionSitDynStandStat = [
    'Able to sit unsupported & weight shift across midline maximally',
    'Able to sit unsupported & weight shift across midline moderately',
    'Able to sit unsupported and weight shift across midline minimally',
    'Minimal weight shifting ipsilateral/front, difficulty crossing midline',
    'Reach to ipsilateral side and unable to weight shift',
    'Able to sit unsupported with min A and reach to ipsilateral side, unable to weight shift',
    'Able to sit unsupported with Mod A and reach ipsilateral/front – can’t cross midline'
];

const standingStaticTopic = 'Standing - Static';
const descriptionStandStat = [
    'Able to maintain standing balance against maximal resistance',
    'Able to maintain standing balance against moderate resistance',
    'Able to maintain standing balance against minimal resistance',
    'Able to stand unsupported without UE support and without LOB for 1-2 min',
    'Requires Min A or UE support in order to stand without LOB',
    'Requires Mod A and UE support to maintain standing without balance loss',
    'Requires Max A and UE support to maintain standing balance without loss'
];

const standingDynamicTopic = 'Standing - Dynamic';
const descriptionStandDyn = [
    'Stand independently unsupported, able to weight shift and cross midline maximally',
    'Stand independently unsupported, able to weight shift and cross midline moderately',
    'Stand independently unsupported, able to weight shift across midline minimally',
    'Stand independently unsupported, weight shift, and reach ipsilaterally, LOB when crossing midline',
    'Able to stand with Min A and reach ipsilaterally, unable to weight shift',
    'Able to stand with Mod A and minimally reach ipsilaterally, unable to cross midline'
];

class PatientCareCenterNoteObjectiveBalance extends React.Component {

    renderToolTip(topic, headings, descriptions) {
        return (
            <ToolTipBulb uid={`${topic}-${this.props.noteId}`} position='right' width={400} size='extra-small'>
                <b>{topic}</b>
                <br />
                {headings.map((heading, index) => (
                    <div className={styles.row} key={index}>
                        <span className={styles.col_1}>{heading}</span>
                        <div className={styles.col_3} />
                        <span>{descriptions[index]}</span>
                    </div>
                ))}
            </ToolTipBulb>
        );
    }


    render() {

        return (
            <PatientCareCenterNoteSection id='obj_balance' name='Balance' level={1}>

                <div className={styles.row}>

                    <ObjectiveFlag className={styles.flag} flagged={this.props.sittingStaticFlagged} flagText={sittingStaticTopic} />
                    <label className={styles.label}>{sittingStaticTopic}</label>
                    <div className={styles.dropdown}>
                        <DBDropDownObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEPEDS'
                            entityKeyColumn='OPNO'
                            entityKeyValue={this.props.opno}
                            field='OPBASITSTATIC'
                            className={styles.arom_hand}
                            masterEntity='PTMASTERBALANCE'
                            masterEntityKeyColumn='MBANO'
                            masterEntitySort='MBAORDER'
                            masterEntityDisplay='MBANAME'
                        />
                    </div>
                    <span className={styles.lightbulb}>
                        {this.renderToolTip(sittingStaticTopic, headingSitStatStandDyn, descriptionSitStatStandDyn)}
                    </span>

                </div>


                <div className={styles.row}>

                    <ObjectiveFlag className={styles.flag} flagged={this.props.sittingDynamicFlagged} flagText={sittingDynamicTopic} />
                    <label className={styles.label}>{sittingDynamicTopic}</label>
                    <div className={styles.dropdown}>
                        <DBDropDownObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEPEDS'
                            entityKeyColumn='OPNO'
                            entityKeyValue={this.props.opno}
                            field='OPBASITDYNAMIC'
                            className={styles.arom_hand}
                            masterEntity='PTMASTERBALANCE'
                            masterEntityKeyColumn='MBANO'
                            masterEntitySort='MBAORDER'
                            masterEntityDisplay='MBANAME'
                        /></div>
                    <span className={styles.lightbulb}>
                        {this.renderToolTip(sittingDynamicTopic, headingSitDynStandStat, descriptionSitDynStandStat)}
                    </span>

                </div>


                <div className={styles.row}>

                    <ObjectiveFlag className={styles.flag} flagged={this.props.standingStaticFlagged} flagText={standingStaticTopic} />
                    <label className={styles.label}>{standingStaticTopic}</label>
                    <div className={styles.dropdown}>
                        <DBDropDownObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEPEDS'
                            entityKeyColumn='OPNO'
                            entityKeyValue={this.props.opno}
                            field='OPBASTANDSTATIC'
                            className={styles.arom_hand}
                            masterEntity='PTMASTERBALANCE'
                            masterEntityKeyColumn='MBANO'
                            masterEntitySort='MBAORDER'
                            masterEntityDisplay='MBANAME'
                        />
                    </div>
                    <span className={styles.lightbulb}>
                        {this.renderToolTip(standingStaticTopic, headingSitDynStandStat, descriptionStandStat)}
                    </span>

                </div>


                <div className={styles.row}>

                    <ObjectiveFlag className={styles.flag} flagged={this.props.wbosFlagged} flagText='NBOS (EO/EC)' />
                    <label className={styles.label}>NBOS (EO/EC)</label>
                    <DBTextFieldObjective
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVEPEDS'
                        entityKeyColumn='OPNO'
                        entityKeyValue={this.props.opno}
                        field='OPBAWBOS'
                        className={styles.column}
                    />

                </div>

                <div className={styles.row}>

                    <ObjectiveFlag className={styles.flag} flagged={this.props.standingDynamicFlagged} flagText={standingDynamicTopic} />
                    <label className={styles.label}>{standingDynamicTopic}</label>
                    <div className={styles.dropdown}>
                        <DBDropDownObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEPEDS'
                            entityKeyColumn='OPNO'
                            entityKeyValue={this.props.opno}
                            field='OPBASTANDDYNAMIC'
                            className={styles.arom_hand}
                            masterEntity='PTMASTERBALANCE'
                            masterEntityKeyColumn='MBANO'
                            masterEntitySort='MBAORDER'
                            masterEntityDisplay='MBANAME'
                        />
                    </div>
                    <span className={styles.lightbulb}>
                        {this.renderToolTip(standingDynamicTopic, headingSitStatStandDyn, descriptionStandDyn)}
                    </span>

                </div>

                <div className={styles.row}>

                    <ObjectiveFlag className={styles.flag} flagged={this.props.slsFlagged} flagText='SLS' />
                    <label className={styles.label}>SLS</label>
                    <DBTextFieldObjective
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVEPEDS'
                        entityKeyColumn='OPNO'
                        entityKeyValue={this.props.opno}
                        field='OPBASLS'
                        className={styles.column}
                    />

                </div>
                <div className={styles.row}>
                    <div className={styles.comments_header}> Comments:</div>
                    <div>
                        <DBTextArea
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEPEDS'
                            entityKeyColumn='OPNO'
                            entityKeyValue={this.props.opno}
                            field='OPBACOMMENT'
                            className={styles.textarea_comment}
                        />
                    </div>
                </div>

                <PatientCareCenterNoteSection id='obj_rhomberg' name='Rhomberg Tests' level={2}>

                    <div className={styles.row}>

                        <ObjectiveFlag className={styles.flag} flagged={this.props.nbosFlagged} flagText='NBOS' />
                        <label className={styles.label_next_level}>NBOS(EO/EC)</label>
                        <DBTextFieldObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEPEDS'
                            entityKeyColumn='OPNO'
                            entityKeyValue={this.props.opno}
                            field='OPBANBOS'
                            className={styles.column}
                        />

                    </div>

                    <div className={styles.row}>

                        <ObjectiveFlag className={styles.flag} flagged={this.props.nbosCompliantFlagged} flagText='NBOS Compliant Surface' />
                        <label className={styles.label_next_level}>NBOS Compliant Surface (EO/EC)</label>
                        <DBTextFieldObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEPEDS'
                            entityKeyColumn='OPNO'
                            entityKeyValue={this.props.opno}
                            field='OPBANBOSCOMPLSURF'
                            className={styles.column}
                        />

                    </div>

                    <div className={styles.row}>

                        <ObjectiveFlag className={styles.flag} flagged={this.props.tandemFlagged} flagText='Tandem' />
                        <label className={styles.label_next_level}>Tandem</label>
                        <DBTextFieldObjective
                            noteId={this.props.noteId}
                            entity='PTOBJECTIVEPEDS'
                            entityKeyColumn='OPNO'
                            entityKeyValue={this.props.opno}
                            field='OPBATANDEM'
                            className={styles.column}
                        />

                    </div>


                </PatientCareCenterNoteSection>
                <div className={styles.row}>
                    <ObjectiveFlag className={styles.flag} flagged={this.props.otherFlagged} flagText='Circumference - Other Measurements' />
                    <label className={styles.lable_space}>Other</label>
                </div>

                <DBTextAreaObjective
                    noteId={this.props.noteId}
                    entity='PTOBJECTIVEPEDS'
                    entityKeyColumn='OPNO'
                    entityKeyValue={this.props.opno}
                    field='OPBAOTHER'
                    className={styles.textArea_row}
                />
                <br />
            </PatientCareCenterNoteSection>
        );
    }

}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let opno = parseInt(Object.keys(state.entities.notes.PTOBJECTIVEPEDS)
        .find(key => (state.entities.notes.PTOBJECTIVEPEDS[key].OPEVNO === pk && noteType === 1)
            || (state.entities.notes.PTOBJECTIVEPEDS[key].OPNTNO === pk && noteType !== 1)));
    return {
        noteId: noteId,
        opno: opno,
        sittingStaticFlagged: (state.entities.notes.PTOBJECTIVEPEDS[opno].OPBASITSTATIC !== undefined
            && state.entities.notes.PTOBJECTIVEPEDS[opno].OPBASITSTATIC !== null
            && state.entities.notes.PTOBJECTIVEPEDS[opno].OPBASITSTATIC !== 1
        ),
        sittingDynamicFlagged: (state.entities.notes.PTOBJECTIVEPEDS[opno].OPBASITDYNAMIC !== undefined
            && state.entities.notes.PTOBJECTIVEPEDS[opno].OPBASITDYNAMIC !== null
            && state.entities.notes.PTOBJECTIVEPEDS[opno].OPBASITDYNAMIC !== 1),
        standingStaticFlagged: (state.entities.notes.PTOBJECTIVEPEDS[opno].OPBASTANDSTATIC !== undefined
            && state.entities.notes.PTOBJECTIVEPEDS[opno].OPBASTANDSTATIC !== null
            && state.entities.notes.PTOBJECTIVEPEDS[opno].OPBASTANDSTATIC !== 1),
        wbosFlagged: (state.entities.notes.PTOBJECTIVEPEDS[opno].OPBAWBOS !== undefined
            && state.entities.notes.PTOBJECTIVEPEDS[opno].OPBAWBOS !== null),
        standingDynamicFlagged: (state.entities.notes.PTOBJECTIVEPEDS[opno].OPBASTANDDYNAMIC !== undefined
            && state.entities.notes.PTOBJECTIVEPEDS[opno].OPBASTANDDYNAMIC !== null
            && state.entities.notes.PTOBJECTIVEPEDS[opno].OPBASTANDDYNAMIC !== 1),
        slsFlagged: (state.entities.notes.PTOBJECTIVEPEDS[opno].OPBASLS !== undefined
            && state.entities.notes.PTOBJECTIVEPEDS[opno].OPBASLS !== null),
        nbosFlagged: (state.entities.notes.PTOBJECTIVEPEDS[opno].OPBANBOS !== undefined
            && state.entities.notes.PTOBJECTIVEPEDS[opno].OPBANBOS !== null),
        nbosCompliantFlagged: (state.entities.notes.PTOBJECTIVEPEDS[opno].OPBANBOSCOMPLSURF !== undefined
            && state.entities.notes.PTOBJECTIVEPEDS[opno].OPBANBOSCOMPLSURF !== null),
        tandemFlagged: (state.entities.notes.PTOBJECTIVEPEDS[opno].OPBATANDEM !== undefined
            && state.entities.notes.PTOBJECTIVEPEDS[opno].OPBATANDEM !== null),
        otherFlagged: (state.entities.notes.PTOBJECTIVEPEDS[opno].OPBAOTHER !== undefined
            && state.entities.notes.PTOBJECTIVEPEDS[opno].OPBAOTHER !== null),
    };
}

const connectedPatientCareCenterNoteObjectiveBalance = connect(mapStateToProps)(PatientCareCenterNoteObjectiveBalance);
export { connectedPatientCareCenterNoteObjectiveBalance as PatientCareCenterNoteObjectiveBalance };